import { Dialog, Grid2 } from "@mui/material";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../store/slices/UI";
import BasicDialogActions from "../../../UI/BasicDialog/BasicDialogActions";
import BasicDialogContent from "../../../UI/BasicDialog/BasicDialogContent";
import BasicDialogTitle from "../../../UI/BasicDialog/BasicDialogTitle";
import Actions from "./Components/Actions";
import Contains from "./Components/Fields/Contains";
import FromDate from "./Components/Fields/DateFrom";
import UntilDate from "./Components/Fields/DateUntil";
import From from "./Components/Fields/From";
import Subject from "./Components/Fields/Subject";

const AdvancedSearch = () => {
  const { dispatch } = useUIBp();

  const onClose = () => {
    dispatch(UIactions.closeModal());
  };

  return (
    <Dialog fullWidth {...{ open: true, onClose, maxWidth: "md" }}>
      <BasicDialogTitle header="Busqueda avanzada" />
      <BasicDialogContent>
        <Grid2 container spacing={1}>
          <From />
          <Subject />
          <Contains />
          <FromDate />
          <UntilDate />
        </Grid2>
      </BasicDialogContent>
      <BasicDialogActions>
        <Actions {...{ onClose }} />
      </BasicDialogActions>
    </Dialog>
  );
};

export default AdvancedSearch;
